export const delay = (ms: number): Promise<void> => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

export function createDelayedPromise<T>(callback: (resolve: (value?: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => void): Promise<T> {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            try {
                callback(resolve, reject);
            } catch (err) {
                console.error(`💥 error in createDelayedPromise: ${err.message}`, err);
                reject(err);
            }
        }, 0);
    });
}

/**
 * Tries its best to wait until the passed time has been reached.
 * returns the difference in ms with the asked time
 * @param time: the DOMHighResTimeStamp to wait until. Use performance.now() to get the current timestamp (https://developer.mozilla.org/en-US/docs/Web/API/DOMHighResTimeStamp)
 */
export const delayUntil = async (time: number): Promise<number> => {
    let diff = time - performance.now();

    while (diff > 0) {
        const timeToWait = Math.floor(diff / 1.5); //Could be optimized, but for now there's no need for it.
        await delay(timeToWait);
        diff = time - performance.now();
    }

    return diff;
};
